import React from 'react';

import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {ProfessionalDateList} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateList';
import {ProfessionalDateSection} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateSection';
import {PreviousProviderCard} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/PreviousProviderCard';
import {translations} from 'presentation/translations-new';
import {HealthProfessionalSelectionNotFoundState} from '../HealthProfessionalSelectionNotFoundState';
import {useHealthSelectedDateProfessionalList} from './hooks/useHealthSelectedDateProfessionalList';
import {HealthSelectedDateProfessionalListProps} from './types';

const {bookHealth} = translations['pt-br'].privateFlow.services;
const {loadingState, loadingError} = translations['pt-br'].privateFlow.bookingFlow.professionalFlow;

export function HealthSelectedDateProfessionalList({
	handleSelectHour,
	handleClearShiftAndSearch,
	filteredProvidersNameOptions,
}: HealthSelectedDateProfessionalListProps) {
	const {
		isLoading,
		isError,
		showNotFoundState,
		selectedDate,
		query,
		setCurrentValueInputTypingState,
		healthAvailableTimesRefetch,
		shouldNotUseHighlight,
		previousProviderData,
		timesWithoutPreviousProvider,
		showPreviousProvider,
	} = useHealthSelectedDateProfessionalList({filteredProvidersNameOptions});

	if (isLoading) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookHealth}
				loadingText={loadingState}
			/>
		);
	}

	if (isError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookHealth}
				errorTitle={loadingError}
				handleRefresh={healthAvailableTimesRefetch}
			/>
		);
	}

	if (showNotFoundState) {
		return (
			<HealthProfessionalSelectionNotFoundState
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_PROFISSIONAL_DISPONIVEL}
				showClearFilterButton
				handleClearShiftAndSearch={() => {
					handleClearShiftAndSearch();
					setCurrentValueInputTypingState('');
				}}
			/>
		);
	}

	return (
		<ProfessionalDateList>
			{showPreviousProvider && previousProviderData ? (
				<PreviousProviderCard
					flowType={FlowEnum.HEALTH}
					professionalCode={previousProviderData.professionalCode}
					professionalName={previousProviderData.professionalName}
					dates={previousProviderData.dates}
					recommendations={previousProviderData.recommendations}
					onSelectHour={handleSelectHour}
					isFavorite={previousProviderData.isFavorite}
				/>
			) : null}
			<ProfessionalDateSection
				date={selectedDate}
				professionals={timesWithoutPreviousProvider ?? []}
				onSelectHour={handleSelectHour}
				flowType={FlowEnum.HEALTH}
				query={query}
				shouldNotUseHighlight={shouldNotUseHighlight}
			/>
		</ProfessionalDateList>
	);
}
